<template>
    <div class="window" v-show="!minimized">
        <div class="window-header">
            <button class="window-minimize" @click="minimizeWindow">
                <!-- <img v-if="!minimized" src="/icons/minimize.svg" alt="Minimize"> -->
                <i :class="minimizeIcon"></i>
            </button>
            <button class="window-close" @click="closeWindow">
                <!-- <img src="/icons/close.svg" alt="Close"> -->
                <i class="fas fa-window-close"></i>
            </button>
        </div>
        <div class="window-content" >
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        minimized: {Boolean}
    },
    methods: {
        minimizeWindow() {
            this.minimized = !this.minimized;
            this.$emit('minimized');

        },
        closeWindow() {
            this.$emit('close');
        },
    },
    computed: {
        minimizeIcon() {
            return this.minimized ? 'far fa-window-maximize' : 'fas fa-window-minimize';
        },
    },
};
</script>
<style>
.window {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 9999;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 100vh;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    background-color: #fff;
    overflow: hidden;
}

.window-header {
    height: 30px;
    background-color: #f2f2f2;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.window-minimize,
.window-close {
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin-right: 5px;
}

.window-content {
    height: calc(100% - 30px);
    padding: 10px;
    overflow: auto;
}
</style>
